import { render, staticRenderFns } from "./AddFeature.vue?vue&type=template&id=ec9d27cc&"
import script from "./AddFeature.vue?vue&type=script&lang=js&"
export * from "./AddFeature.vue?vue&type=script&lang=js&"
import style0 from "./AddFeature.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports